/* istanbul ignore file */
import { TextInput, useFormContext } from 'framework/form';
import { SubmitButton } from 'framework/ui/ui-builder';
import { Button } from 'framework/ui/mui-builder';
import { Box } from '@mui/material';

interface ResolveIncidentFormProps {
  handleCancelClick: () => void;
}

const ResolveIncidentForm = ({ handleCancelClick }: ResolveIncidentFormProps) => {
  const { submitForm, isSubmitEnabled, isLoadingArtifact } = useFormContext();

  return (
    <>
      <TextInput source="processInstanceId" label="Process instance id" isRequired disabled />
      <TextInput source="incidentId" label="Process incident id" isRequired disabled />
      <Box sx={{ display: 'flex', gap: 1.25 }}>
        <SubmitButton
          key="submit-modal-btn"
          onClick={submitForm}
          isLoading={!isSubmitEnabled}
          disabled={isLoadingArtifact}
        />
        <Button
          variant="outlined"
          key="cancel-modal-btn"
          onClick={handleCancelClick}
          disabled={!isSubmitEnabled || isLoadingArtifact}
        >
          Cancel
        </Button>
      </Box>
    </>
  );
};

export default ResolveIncidentForm;
